export const isOnline = payload => ({
    type: 'IS_ONLINE',
    payload,
})
export const keepState = payload => ({
    type: 'KEEP_STATE',
    payload,
})




// WEBPACK FOOTER //
// ./src/actions/appAction.js